import { Center, Loader } from '@mantine/core'

export const PageLoader = () => {
  return (
    <Center h="100%">
      <Loader size="lg" />
    </Center>
  )
}
